/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import { FEED_PUSHER_SETTING } from '../../../constants';

const DropdownListFeedStatus = (props) => (
  <div className="dropdown__list ">
    <div
      className={`dropdown__list-item ${props.league.feedStatus === FEED_PUSHER_SETTING.FEED_STATUS.ACTIVE ? 'active' : ''}`}
      onClick={props.handleFeedStatusChange.bind(this, props.league.leagueId,
        FEED_PUSHER_SETTING.FEED_STATUS.ACTIVE)}
    >
      Active
    </div>
    <div
      className={`dropdown__list-item ${props.league.feedStatus === FEED_PUSHER_SETTING.FEED_STATUS['ALL DISABLED'] ? 'active' : ''}`}
      onClick={props.handleFeedStatusChange.bind(this, props.league.leagueId, FEED_PUSHER_SETTING.FEED_STATUS['ALL DISABLED'])}
    >
      All Disable
    </div>
    <div
      className={`dropdown__list-item ${props.league.feedStatus === FEED_PUSHER_SETTING.FEED_STATUS['ODD DISABLED'] ? 'active' : ''}`}
      onClick={props.handleFeedStatusChange.bind(this, props.league.leagueId, FEED_PUSHER_SETTING.FEED_STATUS['ODD DISABLED'])}
    >
      Odd Disable
    </div>
  </div>
);
export default DropdownListFeedStatus;
